import React, { useEffect, useRef, useState } from "react";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop"
import ThemedLayout from "components/atoms/ThemedLayout"
import i18n from "utils/i18n"
import CacheTab from './_tabs/cache'
import SettingsTabs from './_tabs/settings'
import FooterBar from 'components/organisms/FooterBar'
import EmployeeValues from 'scenes/home/more/_functions/Employee'
import _ from 'lodash'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import LoadingComponent from 'components/atoms/Loading'
import { FooterStyles } from 'styles/components/organisms/Footer'
import HelperString from 'utils/helper-string'
import TabbedContent from 'components/molecules/TabbedContent'
import { FormStatus } from 'utils/constants/form-constants';
import FormSubmitButton from 'components/atoms/FormSubmitButton'
import { TESTID } from '_shared/config/testID'


const HomeMoreSettingsScene = () => {
	
	const layoutRef = useRef()
	
	const _languages = useSelector( state => {
		return state.data[dataConstants.LANGUAGES];
	} )
	
	const [ loading, setLoading ] = useState( true );
	const [ formStatus, setFormStatus ] = useState( FormStatus.NONE );
	const [ topTabbar, setTopTabbar ] = useState( null )
	
	const tabBarItems = [];
	if( _.size( _languages ) > 1 ){
		tabBarItems.push( {
			key: 'settings',
			text: i18n.t( 'tabs.more_settings_settings' ),
			scene: (props) => {
				return <SettingsTabs />;
			}
		});
	}
	
	tabBarItems.push({
		key: 'cache',
		text: i18n.t( 'tabs.more_settings_cache' ),
		scene: ( props ) => {
			return <CacheTab />;
		}
	});
	
	const submitForm = () => {
		EmployeeValues.submitEmployee( setFormStatus );
	}
	
	useEffect( () => {
		EmployeeValues.resetEmployee()
		setLoading( false )
	}, [] );
	
	let submitButton = (
		<FormSubmitButton
			onPress={ submitForm }
			formStatus={ formStatus }
			formStatusCallback={ setFormStatus }
			style={ [ FooterStyles.button, FooterStyles.buttonFill ] }>
			{ i18n.t( 'buttons.save' ) }
		</FormSubmitButton>
	);
	
	let content = <LoadingComponent />
	let footer = null;
	
	if( !loading ) {
		content = (
			<TabbedContent
				key={ HelperString.hash('profile-tabs' ) }
				topTabbar={ setTopTabbar }
				items={ tabBarItems }
			/>
		)
		
		footer = (
			<FooterBar
				buttons={ submitButton }
				onHeightCallback={ layoutRef.current?.setFooterHeight }
			/>
		);
	}
	
	return (
		<ThemedSafeAreaComponentTop top={false}>
			<ThemedLayout
				ref={ layoutRef }
				topNavigation={ true }
				topTabbar={ topTabbar }
				showBackButton={ true }
				title={ i18n.t( 'titles.more_settings') }
				testID={ TESTID.HOME.MORE.SCREENS.SETTINGS }>
				
				{ content }
			</ThemedLayout>
			
			{ footer }
		</ThemedSafeAreaComponentTop>
	);
}

export default HomeMoreSettingsScene;
